import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BgxLocationService } from './location.service';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [BgxLocationService],
})
export class BgxLocationModule {}
